import { Radio } from "antd";
import React from "react";

const LanguageCard = ({ currentLanguage, handleSetLanguage }) => {
  return (
    <>
      <Radio.Group
        className="w-100 common-radio-section-auth"
        name="radiogroup"
        onChange={(e) => handleSetLanguage(e.target.value)}
        value={currentLanguage}
      >
        <div className="row language-select-row">
          <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <Radio.Button value="en">
              <div className="row">
                <div className="col-12">
                  <img
                    src="/assets/images/icons/english-flag.svg"
                    className="img-fluid"
                    alt="flag icon"
                  />
                  <h6 className="mb-0">English</h6>
                </div>
              </div>
            </Radio.Button>
          </div>
          <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <Radio.Button value="es">
              <div className="row">
                <div className="col-12">
                  <img
                    src="/assets/images/icons/spanish-flag.svg"
                    className="img-fluid"
                    alt="flag icon"
                  />
                  <h6 className="mb-0">Español</h6>
                </div>
              </div>
            </Radio.Button>
          </div>
          <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <Radio.Button value="fr">
              <div className="row">
                <div className="col-12">
                  <img
                    src="/assets/images/icons/french-flag.svg"
                    className="img-fluid"
                    alt="flag icon"
                  />
                  <h6 className="mb-0">Français</h6>
                </div>
              </div>
            </Radio.Button>
          </div>
          <div className="col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <Radio.Button value="hi">
              <div className="row">
                <div className="col-12">
                  <img
                    src="/assets/images/icons/indian-flag.svg"
                    className="img-fluid"
                    alt="flag icon"
                  />
                  <h6 className="mb-0">Hindi</h6>
                </div>
              </div>
            </Radio.Button>
          </div>
        </div>
      </Radio.Group>
    </>
  );
};

export default LanguageCard;
